import * as types from './weaveColorActionTypes';

const initialState = {
  weaveColorData: null,
  weaveColorList: [],
  createWeaveColorData: null,
  createWeaveColorError: null,
  updateWeaveColorData: null,
  updateWeaveColorError: null,
  deleteWeaveColorData: null,
  deleteWeaveColorError: null,
};

export const weaveColorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WEAVECOLOR_DATA:
      return {
        ...state,
        weaveColorData: action.payload || null,
        weaveColorList: action.payload?.WeaveColorList || [],
      };
    case types.GET_WEAVECOLOR_ERROR:
      return {
        ...state,
        weaveColorData: null,
        weaveColorList: [],
      };

    case types.CREATE_WEAVECOLOR_DATA:
      return {
        ...state,
        createWeaveColorData: action.payload,
        createWeaveColorError: null,
      };
    case types.CREATE_WEAVECOLOR_ERROR:
      return {
        ...state,
        createWeaveColorData: null,
        createWeaveColorError: action.payload,
      };

    case types.UPDATE_WEAVECOLOR_DATA:
      return {
        ...state,
        updateWeaveColorData: action.payload,
        updateWeaveColorError: null,
      };
    case types.UPDATE_WEAVECOLOR_ERROR:
      return {
        ...state,
        updateWeaveColorData: null,
        updateWeaveColorError: action.payload,
      };

    case types.DELETE_WEAVECOLOR_DATA:
      return {
        ...state,
        deleteWeaveColorData: action.payload,
        deleteWeaveColorError: null,
      };
    case types.DELETE_WEAVECOLOR_ERROR:
      return {
        ...state,
        deleteWeaveColorData: null,
        deleteWeaveColorError: action.payload,
      };

    default:
      return state;
  }
};
